import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { Part } from 'src/app/model/station-logs/part';

@Injectable({
  providedIn: 'root',
})
export class PartsTableService extends BaseTableService<Part> {
  constructor() {
    super();
  }
}
